import { useEffect, useState } from 'react';
import { checksumAddress, type Address } from 'viem';
import { useAccount } from './useAccount';
import { useDisconnect } from './useDisconnect';
import { useModalError } from './useModalError';
import { useSmartAccount } from './useSmartAccount';

export const useAddress = (): string | undefined => {
  const { address: eoaAddress, chain } = useAccount();
  const smartAccount = useSmartAccount();
  const { disconnect } = useDisconnect();
  const { showError } = useModalError();

  const [address, setAddress] = useState<string>();

  useEffect(() => {
    if (smartAccount && eoaAddress && eoaAddress.startsWith('0x')) {
      setAddress(undefined);
      if (chain) {
        smartAccount
          .getAddress()
          .then((result) => {
            if (smartAccount) {
              if (result) {
                setAddress(checksumAddress(result as Address));
              } else {
                setAddress(undefined);
              }
            } else {
              if (eoaAddress === '0x0000000000000000000000000000000000000000') {
                setAddress(undefined);
              } else {
                setAddress(eoaAddress);
              }
            }
          })
          .catch((error) => {
            console.log('get smart account error', error);
            disconnect();
            setTimeout(() => showError(error.message), 10);
          });
      } else {
        setAddress(undefined);
        console.log('show chain error, must switch chain before get AA.');
      }
    } else {
      if (eoaAddress === '0x0000000000000000000000000000000000000000') {
        setAddress(undefined);
      } else {
        setAddress(eoaAddress);
      }
    }
  }, [eoaAddress, smartAccount, disconnect, chain]);

  return address;
};
